import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=21a1eb97&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a1eb97')) {
      api.createRecord('21a1eb97', component.options)
    } else {
      api.reload('21a1eb97', component.options)
    }
    module.hot.accept("./StatusDropdown.vue?vue&type=template&id=21a1eb97&", function () {
      api.rerender('21a1eb97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/components/StatusDropdown.vue"
export default component.exports